export type FeedCategory = '全部' | '娱乐' | '影视' | '综艺' | '社会' | '资讯' | '热梗';

export interface FeedItem {
  id: number;
  cat: Exclude<FeedCategory, '全部'>;
  tag: string;
  title: string;
  summary: string;
  time: string;
  heat: string;
  hot?: boolean;
  badge?: string;
}

export const feedCats: FeedCategory[] = ['全部', '娱乐', '影视', '综艺', '社会', '资讯', '热梗'];

export const feedItems: FeedItem[] = [
  {
    id: 1,
    cat: '娱乐',
    tag: '星闻',
    title: '实力派阵容官宣新舞台企划，首波造型路透抢先曝光',
    summary: '多位话题度拉满的艺人同台的消息引发讨论，首波预告片花释出后被网友逐帧解读，猜测舞台主题与联动可能。',
    time: '21:48',
    heat: '热度 128.6 万',
    hot: true,
    badge: '爆',
  },
  {
    id: 2,
    cat: '影视',
    tag: '档期',
    title: '暑期档黑马大片定档，实时预售数据持续走高',
    summary: '一部聚焦成长与友情的合家欢影片官宣定档暑期，实时预售与想看人数在档期日历上一路攀升，影院排片随之上调。',
    time: '21:32',
    heat: '热度 96.2 万',
  },
  {
    id: 3,
    cat: '综艺',
    tag: '路透',
    title: '新一季户外真人秀录制被偶遇，路透阵容疑似曝光',
    summary: '多地网友拍到节目组转场画面，关于嘉宾阵容与主题任务的猜测迅速刷屏，节目方暂未回应引发二轮热议。',
    time: '21:15',
    heat: '热度 83.7 万',
    hot: true,
    badge: '热',
  },
  {
    id: 4,
    cat: '社会',
    tag: '热议',
    title: '多城迎文旅消费季，市集夜游新玩法刷屏朋友圈',
    summary: '结合非遗、市集与城市漫游的文旅新活动集中亮相，年轻人打卡热情高涨，相关话题讨论度与线下客流同步升温。',
    time: '20:56',
    heat: '热度 71.4 万',
  },
  {
    id: 5,
    cat: '资讯',
    tag: '科技',
    title: '新一代消费级数码新品集中发布，价格与配置引对比',
    summary: '多品牌在同一时段上新，围绕续航、影像与生态互联的横向对比成为热门内容，准入门槛话题也被反复讨论。',
    time: '20:40',
    heat: '热度 64.8 万',
  },
  {
    id: 6,
    cat: '热梗',
    tag: '梗图',
    title: '「这波属于是把悬念拉满了」成为今日高频热梗',
    summary: '一句综艺预告中的口头禅被网友截图搬运，配合各种"反转剧情"梗图走红，二次创作量在几个小时内成倍上涨。',
    time: '20:22',
    heat: '热度 52.3 万',
    badge: '新',
  },
  {
    id: 7,
    cat: '娱乐',
    tag: '圈内',
    title: '音乐节名单流出一张被删，猜测名单全网接力再整理',
    summary: '一份疑似音乐节演出名单短暂露出后被撤回，粉丝与乐迷按线索接力整理，票价与开票时间成为下一个焦点。',
    time: '20:05',
    heat: '热度 48.9 万',
  },
  {
    id: 8,
    cat: '影视',
    tag: '收官',
    title: '口碑悬疑剧迎来大结局，实时讨论热度再创新高',
    summary: '多线伏笔在结局集中回收，观众在弹幕与社区里复盘线索，关于结局解读与续作可能的讨论持续霸榜多时。',
    time: '19:47',
    heat: '热度 92.1 万',
    hot: true,
    badge: '爆',
  },
  {
    id: 9,
    cat: '综艺',
    tag: '官宣',
    title: '唱作类音乐综艺官宣新一季，导师与飞行阵容成谜',
    summary: '官方一图流官宣新季启动，通过剪影与细节埋下大量彩蛋，网友据此进行身份推理，答案揭晓被顶上话题榜。',
    time: '19:30',
    heat: '热度 45.6 万',
  },
  {
    id: 10,
    cat: '社会',
    tag: '暖闻',
    title: '城市夜跑补给站自发集结，志愿者故事打动无数网友',
    summary: '一处由热心市民自发搭建的夜跑补给点走红，朴实的小纸条与矿泉水被晒到网上，善意话题带来大量暖心互动。',
    time: '19:12',
    heat: '热度 38.4 万',
  },
  {
    id: 11,
    cat: '资讯',
    tag: '消费',
    title: '夏日主题市集经济升温，新消费观察报告出炉',
    summary: '从夜市到周末限定市集，线下"逛吃玩"消费力释放明显，报告显示体验型消费占比提升，年轻客群占比过半。',
    time: '18:55',
    heat: '热度 33.7 万',
  },
  {
    id: 12,
    cat: '热梗',
    tag: '流行',
    title: '「嘴硬王者」称号被网友玩出各种限定版本',
    summary: '由一段对话切片演变而来的"嘴硬王者"句式，被套用到学习、健身、上班等场景，表情包产量持续增加。',
    time: '18:40',
    heat: '热度 41.2 万',
  },
  {
    id: 13,
    cat: '娱乐',
    tag: '红毯',
    title: '品牌盛典红毯造型盘点，出场顺序成为今日话题',
    summary: '一场时尚盛典红毯上多位嘉宾造型同步释出，网友自发投票盘点最佳与最具话题穿搭，实时统计在评论区不断刷新。',
    time: '18:22',
    heat: '热度 57.8 万',
  },
  {
    id: 14,
    cat: '影视',
    tag: '花絮',
    title: '剧集片场花絮泄露"名场面"拍摄幕后，意外搞笑',
    summary: '一段幕后花絮展示某"高能名场面"的拍摄过程，与正片画风反差强烈，网友直呼演员与剧组全员"戏精上身"。',
    time: '18:06',
    heat: '热度 36.9 万',
  },
  {
    id: 15,
    cat: '综艺',
    tag: '预告',
    title: '推理综艺本季终章预告上线，观众开启全员复盘',
    summary: '终章预告抛出多组关键镜头，节目社区里已有人梳理时间线并给出多种作案假设，正片开播前的讨论达到顶点。',
    time: '17:50',
    heat: '热度 29.5 万',
  },
  {
    id: 16,
    cat: '社会',
    tag: '城市',
    title: '地铁新线路试运行，沿线打卡攻略连夜出炉',
    summary: '一条串联多个商圈与文化地标的新线路进入试运行，博主与居民连夜整理换乘与打卡攻略，首日体验帖刷屏。',
    time: '17:34',
    heat: '热度 26.8 万',
  },
  {
    id: 17,
    cat: '资讯',
    tag: '文娱',
    title: '年度网络文艺作品观察报告发布，口碑数据引讨论',
    summary: '报告从播放、口碑与话题发酵多维度盘点过去一年的现象级内容，行业与观众对其中的评判标准各抒己见。',
    time: '17:18',
    heat: '热度 22.6 万',
  },
  {
    id: 18,
    cat: '娱乐',
    tag: '动态',
    title: '夏日音乐现场连开三城，抢票攻略与转场信息汇总',
    summary: '多位音乐人公布的夏日演出计划集中落地，跨城追现场的乐迷开始汇总票务与转场信息，形成实时更新攻略帖。',
    time: '17:02',
    heat: '热度 31.4 万',
  },
  {
    id: 19,
    cat: '影视',
    tag: '新片',
    title: '动画电影全新预告释出，画风与配乐获一致好评',
    summary: '一部手绘质感动画电影发布全新预告，独特的色彩语言与配乐瞬间圈粉，点映场次信息成为网友最关心的问题。',
    time: '16:46',
    heat: '热度 27.3 万',
  },
  {
    id: 20,
    cat: '热梗',
    tag: '二创',
    title: '「瓜田里的猹」二创合集冲上热搜，看瓜文学再翻红',
    summary: '以"猹"自喻围观网友的二创内容集中涌现，从表情包到段子再到短视频配音，形成一套完整的看瓜亚文化话语。',
    time: '16:30',
    heat: '热度 35.1 万',
    badge: '热',
  },
];